

import { FieldSelectOptions, isFieldMultiSelectUser, isFieldSelectUser, isString, isStringArray } from '@taida-corp/taidacorp-sdk';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSelectUsersOptions } from '../../../../../../data/users/selectors';
import { RecordInputComponentProps } from '../base';

export const SelectUserInputComponent = ({
  field,
  value: persistedValue,
  onChange,
  extraProps = {},
}: RecordInputComponentProps) => {
  const userOptions:FieldSelectOptions = useSelector(getSelectUsersOptions);
  const isMultiple = useMemo(() => isFieldMultiSelectUser(field), [field]);
  const errors = useMemo(() => {
    if (persistedValue === undefined || !isStringArray(persistedValue.errors)) {
      return [] as string[];
    }
    return persistedValue.errors;
  }, [persistedValue])
  const value = useMemo(() => {
    if (persistedValue === undefined) {
      return '';
    }
    if(isMultiple) {
      if(!isStringArray(persistedValue.internalValue)) {
        return '';
      }
    } else {
      if(!isString(persistedValue.internalValue)) {
        return '';
      }
    }

    return persistedValue.internalValue;
  }, [isMultiple, persistedValue]);
  const onChangeHandle = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      if(isMultiple) {
        onChange({internalValue: Array.from(event.target.selectedOptions, option => option.value)});
      } else {
        if(event.target.value === '--') {
          onChange({internalValue: null});
        } else {
          onChange({internalValue: event.target.value ?? ''});
        }
      }
    },
    [onChange, isMultiple],
  );
  if(!isFieldSelectUser(field) && !isFieldMultiSelectUser(field)) {
    return <div>{`Error this is not a select user field ${field.fieldId}`}</div>
  }
  return (
    <>
    <select
      className="form-select"
      id={`field-${field.fieldId}`}
      value={value}
      onChange={onChangeHandle}
      multiple={isMultiple}
      {...extraProps}
    >
      {!isMultiple && <option value={undefined}>--</option>}
      {userOptions.map((fieldOption) => (
        <option key={fieldOption.value} value={fieldOption.value}>{fieldOption.label}</option>
      ))}
      </select>
    {errors.map((err) => <div key={err} className='mt-1'><small className='text-danger'>{err}</small></div>)}
    </>
  );
};

export default SelectUserInputComponent;
